var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyLinkinline = function SvgCopyLinkinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.97 14.417a1 1 0 0 0-.084-.303l-.023-.043a1 1 0 0 0-.194-.276 3.92 3.92 0 0 0-2.78-1.15 3.92 3.92 0 0 0-2.78 1.15L8.4 17.502a3.937 3.937 0 0 0 0 5.56 3.92 3.92 0 0 0 2.78 1.15 3.92 3.92 0 0 0 2.781-1.15l2.182-2.182a5.5 5.5 0 0 1-2.157-.877l-1.542 1.542c-.674.675-1.852.675-2.527 0a1.79 1.79 0 0 1 0-2.526l2.028-2.028.002-.002 1.677-1.677a1.78 1.78 0 0 1 .928-.49 1.79 1.79 0 0 1 1.599.49c.419.419 1.099.419 1.517 0 .145-.146.237-.324.281-.51l.005-.015q.033-.16.02-.323z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.597 8.94a3.9 3.9 0 0 0-2.78-1.152c-1.05 0-2.038.41-2.78 1.152l-2.185 2.184A5.5 5.5 0 0 1 18.01 12l1.544-1.543c.675-.675 1.852-.675 2.526 0 .337.337.523.786.523 1.263 0 .478-.186.926-.524 1.263l-.68.68q0 .002-.002.003l-3.024 3.024c-.674.674-1.851.674-2.526 0a1.072 1.072 0 1 0-1.517 1.517 3.9 3.9 0 0 0 2.78 1.152c1.05 0 2.038-.41 2.78-1.152l3.025-3.024.003-.002.679-.68a3.9 3.9 0 0 0 1.152-2.78c0-1.05-.41-2.038-1.152-2.781"
  })));
};
export default SvgCopyLinkinline;